<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}</div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div class="top-arrow hasTop" v-if="box.component == 'buttons'">
                <div class="top-arrow-text">Hochscrollen für weitere Muster</div>
            </div>
            <div :id="box.component" class="fabric-select-btns">

                <div v-for="item in items"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]">
                    <img v-bind:src="this.baseurl + 'media/' + item.thumb" v-bind:alt="item.name"
                         v-bind:title="item.name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code"/>
                    <div class="name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code">{{ item.name }}
                    </div>
                    <button v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]"
                            v-bind:data-refnr="item.ref_number"
                            v-bind:data-title="item.name" v-bind:data-infotext='item.infotext'
                            v-bind:data-price='item.price'
                            type="button" @click="zoomFabric">Details
                    </button>
                </div>
            </div>
        </div>
        <div class="bottom-arrow hasTop" v-if="box.component == 'buttons'">
            <div class="bottom-arrow-text">Runterscrollen für weitere Muster</div>
        </div>

        <div class="designer-select-dropdown">
            <div class="designer-select-dropdown-col">
                <h3>{{ translations['Collar Buttons'] }}</h3>
                <div class="designer-select">
                    <select title="{{ translations['Second Collar Button'] }}" id="collarbuttons" name="second_button"
                            v-model="selected"
                            @change="updatePersonalCollar">
                        <option value="onebutton">{{ translations['1 Button'] }}</option>
                        <option value="twobutton">{{ translations['2 Buttons'] }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="designer-select-dropdown">
            <div class="designer-select-dropdown-col">
                <h3>{{ translations['Collar Strength'] }}</h3>
                <div class="designer-select">
                    <select title="{{ translations['Collar Strength'] }}" id="collar_strength" name="collar_strength"
                            v-model="selected_strength"
                            @change="updatePersonalCollarStrength">
                        <option value="solid">{{ translations['solid'] }}</option>
                        <option v-if="personal['collar']!='standup' && personal['collar']!='smoking'" value="weak">{{ translations['weak'] }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals"></zoom>
</template>


<script>
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'Cuff',
  data: function () {
    return {
      selected: (typeof this.personal['collarbuttons'] !== 'undefined' ? this.personal['collarbuttons'] : ''),
      selected_strength: (typeof this.personal['collar_strength'] !== 'undefined' ? this.personal['collar_strength'] : ''),
      selected_height: (typeof this.personal['collar_height'] !== 'undefined' ? this.personal['collar_height'] : ''),
      globals: window.shirtdesigner,
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      },
      personal: this.personal
    }
  },
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'zoom', 'show', 'translations' ],
  components: {
    Zoom
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.isactive = event.currentTarget.id
    },
    updatePersonalCollar: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected])
    },
    updatePersonalCollarHeight: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected_height])
    },
    updatePersonalCollarStrength: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected_strength])
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    }
  },
  watch: {
    items: function () {
      this.checkMeasures()
    },
    filtertext: function () {
      this.checkMeasures()
    }
  },
  ready: function () {
    this.checkMeasures()
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Collar.vue?3b0877b1